import { useRequest, UseRequestStatus } from '.'

export default Object.assign(useRequest, { useRequest, UseRequestStatus })
